setTimeout(() =>{
    function handleButtonClick(e) {
      e.preventDefault();
      const $button = $(this);
      let oldText = $(this).text();
      $button.css({'pointer-events': 'none', 'opacity': '0.6'});
      $button.text("Loading ...");
      setTimeout(() =>{
        $button.css({'pointer-events': 'unset', 'opacity': '1'})
          $button.text(oldText);
      }, 2000);
    }
   
   $(document).on('click dblclick', 'button[name="checkout"]', handleButtonClick);
  }, 500)

BSS_B2B.customTriggerCheckoutBtn = function(){
    window.location.href = '/checkout'
}

let counter = 0;
let selector = ".bss-qb-price-item";

const interval = setInterval(() => {
    let element = document.querySelector(selector);

    if (element) {
        console.log("Phần tử đã xuất hiện");

        // text theo locale
        let discountText = 'Remise';

        if (Shopify.locale === 'de') {
            discountText = 'Rabatt';
        }

        // lấy tất cả cart item
        const items = document.querySelectorAll('.cart-item');

        items.forEach((item) => {
            const originalEl = item.querySelector('[bss-b2b-item-original-price]');
            const saleEl = item.querySelector('.bss-qb-price-item');

            if (!originalEl || !saleEl) return;

            // tránh duplicate
            if (item.querySelector('.bss-discount-percent')) return;

            const getPrice = (text) => {
                return parseFloat(
                    text
                        .replace(/[^\d.,]/g, '')
                        .replace(',', '.')
                );
            };

            const originalPrice = getPrice(originalEl.textContent);
            const salePrice = getPrice(saleEl.textContent);

            // invalid price
            if (!originalPrice || !salePrice) return;

            // tính %
            const discountPercent = Math.round(
                ((originalPrice - salePrice) / originalPrice) * 100
            );

            const discountEl = document.createElement('span');

            discountEl.className = 'bss-discount-percent';
            discountEl.textContent = ` ${discountText}: ${discountPercent}%`;

            discountEl.style.color = 'green';
            discountEl.style.margin = '0 8px';
            discountEl.style.fontWeight = '700';

            // append ngay sau giá gốc
            originalEl.insertAdjacentElement('afterend', discountEl);
        });

        clearInterval(interval);

    } else {
        counter += 100;

        if (counter >= 10000) {
            clearInterval(interval);
        }
    }
}, 100);

if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
    setTimeout(() => {
      const observer = new MutationObserver((MutationList) => {
        for (let item of MutationList) {
          if (item.target.classList?.contains('product-option')) {
            console.log("Phần tử đã xuất hiện 1");

            // text theo locale
        let discountText = 'Remise';

        if (Shopify.locale === 'de') {
            discountText = 'Rabatt';
        }

        // lấy tất cả cart item
        const items = document.querySelectorAll('.cart-item');

        items.forEach((item) => {
            const originalEl = item.querySelector('[bss-b2b-item-original-price]');
            const saleEl = item.querySelector('.bss-qb-price-item');

            if (!originalEl || !saleEl) return;

            // tránh duplicate
            if (item.querySelector('.bss-discount-percent')) return;

            const getPrice = (text) => {
                return parseFloat(
                    text
                        .replace(/[^\d.,]/g, '')
                        .replace(',', '.')
                );
            };

            const originalPrice = getPrice(originalEl.textContent);
            const salePrice = getPrice(saleEl.textContent);

            // invalid price
            if (!originalPrice || !salePrice) return;

            // tính %
            const discountPercent = Math.round(
                ((originalPrice - salePrice) / originalPrice) * 100
            );

            const discountEl = document.createElement('span');

            discountEl.className = 'bss-discount-percent';
            discountEl.textContent = ` ${discountText}: ${discountPercent}%`;

            discountEl.style.color = 'green';
            discountEl.style.margin = '0 8px';
            discountEl.style.fontWeight = '700';

            // append ngay sau giá gốc
            originalEl.insertAdjacentElement('afterend', discountEl);
        });
          }
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }, 300);
  }